import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/utils/onbox";
import * as Sentry from '@sentry/vue'
Vue.config.devtools = true;
Vue.config.productionTip = false;

Vue.prototype.chatVersion = '2.48' // 聊天：2.4 多模型；2.4.1 多模态；2.4.2 多模态（运营位卡片&banner）；2.46.1 曝光打点 isIni；2.48 修复问答参数 messages 偶数个问题，切换账号历史记录显示问题
Vue.prototype.searchVersion = '2.48' // 搜索：2.43.1 首页刷新逻辑；2.4.2 百度 AI 搜索；2.46.1 曝光打点 isIni & 历史记录数据结构优化刷新；2.48 炽魂
Vue.prototype.writeVersion = '2.48' // 写作：2.2 追问/分享；2.46.1 曝光打点 isIni；2.48 炽魂
Vue.prototype.translateVersion = '2.46.1' // 翻译：2.4 第一版；2.46.1 曝光打点 isIni
Vue.prototype.gameVersion = '2.48' // 小游戏：2.43.1 首页刷新逻辑；2.46.1 曝光打点 isIni；2.48 炽魂
Vue.prototype.customAddVersion = '2.46.1' // 自定义添加：2.43.1 首页刷新逻辑；2.46.1 曝光打点 isIni

import "element-ui/lib/theme-chalk/index.css";
import "@/assets/css/theme.scss"; // 覆盖ElementUI原有样式
import {
  Button,
  Input,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Tag,
  Dialog,
  Tooltip,
  Scrollbar,
  Popover,
  Row,
  Col,
  Upload,
  Image,
} from "element-ui";
import NetworkError from "@/components/NetworkError/index.vue";
Vue.component("NetworkError", NetworkError);
Vue.use(Button);
Vue.use(Input);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Tag);
Vue.use(Dialog);
Vue.use(Tooltip);
Vue.use(Popover);
Vue.use(Scrollbar);
Vue.use(Row);
Vue.use(Col);
Vue.use(Upload);
Vue.use(Image);

import resetMessage from "@/utils/resetMessage";
Vue.prototype.$message = resetMessage;

import "@/assets/css/base.css";
import VueLazyload from "vue-lazyload";
import VueClipboard from "vue-clipboard";

Vue.use(VueClipboard);

Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1,
  adapter: {
    error(listender) {
      // 网页总结缩略图加载失败，删除Dom
      if (
        listender &&
        listender.el &&
        listender.el.parentNode.classList.contains("rt")
      ) {
        listender.el.parentNode.classList.add("f-dn");
      }
    },
  },
});

// import './mock/mockServe.js'

// import VConsole from 'vconsole'
// const vConsole = new VConsole()
// // vConsole.destroy()
// const dom = document.getElementById('__vconsole')
// dom.style.display = 'none'
// if (window.location.pathname.indexOf('ai_write_details') > -1 && window.location.search.indexOf('debugger=true') > -1) {
//   dom.style.display = 'block'
// }

import VueClipBoard from "vue-clipboard2";
Vue.use(VueClipBoard);

import { handleConsoleLog } from "@/utils";
handleConsoleLog();

import "@/utils/vDirective.js"; // 自定义指令

import "@/components/common/index"; // 全局组件

Sentry.init({
  Vue,
  release: `h5-aistick-web@${process.env.NODE_ENV}`,
  environment: process.env.NODE_ENV,
  dsn: "https://3c97aec47172e9714606e8624c44737b@sentry-lb.lenovo.com.cn/59",
  tracesSampleRate: 1.0 
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

// console.log(process.env)
